import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { apiClient, RECAPTCHA_TOKEN_HEADER } from '@/lib/api-client';
import type { ApiError } from '@/types/api.types';
import type { ProviderAccessRequest, ProviderAccessResponse } from '../types/auth.types';

/**
 * Provider access check (US-001, US-002). A mutation rather than a query: the request carries a
 * single-use reCAPTCHA token, so it must never be replayed from cache or refetched in the background.
 */
export function useProviderLogin(): UseMutationResult<
  ProviderAccessResponse,
  ApiError,
  ProviderAccessRequest
> {
  return useMutation<ProviderAccessResponse, ApiError, ProviderAccessRequest>({
    mutationFn: async ({ recaptchaToken, ...request }) => {
      const response = await apiClient.post<ProviderAccessResponse>(
        '/api/provider-access/verify',
        request,
        { headers: { [RECAPTCHA_TOKEN_HEADER]: recaptchaToken } },
      );

      return response.data;
    },
  });
}
